import { css } from '@emotion/react';
import { Gray, Main, White } from '@constants/color';

export const focusableInput = css({
  width: 752,
  backgroundColor: 'transparent',
  outline: 0,
  borderWidth: '0 0 4px',
  borderColor: Gray.Gray80,
  fontSize: 40,
  lineHeight: '52px',
  fontWeight: 700,
  color: White.White10,
  paddingBottom: 16,
  '::placeholder': {
    color: Gray.Gray70,
    fontSize: 40,
    lineHeight: '52px',
    fontWeight: 700
  }
});

export const focusedInput = css({
  borderColor: Main.priBlue
});
